import axios from "axios";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Modal } from "react-materialize";

const QueueRow = ({orderItems}) => {
  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setInterval(function() {
      let secs = moment().diff(orderItems.data.now, 'seconds');
      let timeWaited = moment.utc(secs*1000).format('HH:mm:ss')
      setTime(timeWaited)
  }, 1 * 1000); // 60 * 1000 milsec
  }, []);

  const onDelete = (event) => {
      setLoading(true)
    axios.delete(`/ticket/${orderItems.ticketId}`).then(() => {
      console.log(`deleted ticket ${orderItems.ticketId}`);
      window.location.reload();
      setLoading(false)
    });
  };

  const onDeleteComplete = (event) => {
      const completedTicket = {
        title: orderItems.data.title,
        rating: orderItems.data.rating,
        serviceName: orderItems.data.serviceName,
        userName: orderItems.data.userName,
        userPhone: orderItems.data.userPhone,
        now: orderItems.data.now,
        displayNow: orderItems.data.displayNow,
        category: orderItems.data.category,
      }
    setTimeout(() => {
        axios.post(`/completeTicket`, completedTicket).then(() => {
            axios.delete(`/ticket/${orderItems.ticketId}`).then(() => {
                console.log(`completed ticket for ${orderItems.data.userName}`);
                window.location.reload();
              });
          });
   }, 1000);
};



  return (
    <>
              <div className="row">
                <table className="order-category-wrapper striped left">
                  <tbody>
                    <tr key={orderItems.ticketId}>
                      <td className="table-col">
                        <div className="switch">
                          <label>
                            <input type="checkbox" onClick={onDeleteComplete}/>
                            <span className="lever"></span>
                          </label>
                        </div>
                      </td>
                      <td className="table-col">{orderItems.data.userName}</td>
                      <td className="table-col">{orderItems.data.title}</td>
                      <td className="table-col">{orderItems.data.userPhone}</td>
                      <td className="table-col">
                        {orderItems.data.displayNow}
                      </td>
                      <td className="table-col">{time}</td>
                      <td className="table-col">
                      <Modal
                  trigger={
                    <button className="btn delete-queue">
                      <FontAwesomeIcon
                        className="blk"
                        icon={faTrash}
                        size="s"
                      />
                    </button>
                  }
                >
                  <div className="modal-container">
                    <h4>Confirm Delete</h4>
                    <p>Are you sure you want to delete this from your queue?</p>
                    <button className="btn submit-button" onClick={onDelete}>
                      Yes, Delete{" "}
                    </button>
                  </div>
                </Modal>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
           
    </>
  );
};

export default QueueRow;
